export default __webpack_public_path__ + "static/media/statExchanges.d66e24ab.svg";